module.exports = "/assets/9e3f2f9895e888bc0f6ca80c1f81cf14.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/2P.png
// module id = 2122
// module chunks = 0